<template>
	<lv-base-column
		ref="column"
		v-bind="columnBinding"
		:lov="lovType"
		:externalData="{lovType,parentLovType,parentLovValue,parentValidMessage,excludeLov}">
		<template slot-scope="{row,rowIndex,col,colIndex,editRow,fixedRow}">
			<link-table-column-lov-item
				:row="row"
				:edit-row="editRow"
				:row-index="rowIndex"
				:col="col"
				:col-index="colIndex"
				:fixed-row="fixedRow"
				v-bind="columnItemBinding"
				@click="lv_clickItem"

				:lov-type="lovType"
				:lovTypeFunc="lovTypeFunc"
				:parent-lov-type="parentLovType"
				:parent-lov-value="parentLovValue"
				:parent-lov-value-field="parentLovValueField"
				:parent-valid-message="parentValidMessage"
				:exclude-lov="excludeLov"
				:beforeSelect="beforeSelect"
				:afterSelect="afterSelect"
				@change="val=>$emit('change',val)"
			/>
		</template>
	</lv-base-column>
</template>

<script>

import {ColumnMixin} from "../mixins";
import LinkTableColumnLovItem from "./link-table-column-lov-item";
import LvBaseColumn from "../../table/lv-base-column";
import {formatLovString} from "./formatLovString";

export default {
	name: "link-table-column-lov",
	components: {LinkTableColumnLovItem, LvBaseColumn},
	mixins: [ColumnMixin,],
	props: {
		width: {default: 100},
		autoMulti: {type: Boolean, default: true}, //是否自动对多值字串进行转换
		lovType: {type: String},
		lovTypeFunc: {type: Function},
		filterName: {default: 'lov'},
		parentLovType: {type: String},
		parentLovValue: {type: String},
		parentLovValueField: {type: String},
		parentValidMessage: {type: String},
		excludeLov: {type: Array},

		beforeSelect: {},
		afterSelect: {},

		formatter: {
			default() {
				return async (val, {showRow, rowIndex}) => {
					return await formatLovString({
						lovType: this.lovType,
						lovTypeFunc: this.lovTypeFunc,
						parentLovType: this.parentLovType,
						parentLovValue: this.parentLovValue,
						parentLovValueField: this.parentLovValueField,
						excludeLov: this.excludeLov,
						$lov: this.$lov,
						row: showRow,
						rowIndex,
						multiple: this.autoMulti,
						val,
					})
				}
			},
		},
		translate: {
			default() {
				return async (val) => {
					if (!this.lovType) throw new Error('动态值列表暂不支持列筛选功能！')
					return await formatLovString({
						lovType: this.lovType,
						lovTypeFunc: this.lovTypeFunc,
						parentLovType: this.parentLovType,
						parentLovValue: this.parentLovValue,
						parentLovValueField: this.parentLovValueField,
						excludeLov: this.excludeLov,
						$lov: this.$lov,
						row: {},
						rowIndex: -1,
						multiple: this.autoMulti,
						val,
					})
				}
			},
		},
		getFiltersRawBySortFilterText: {
			default() {
				return async (filterText) => {
					let {lovs} = await this.$lov.getLovData(this.lovType, this.parentLovType, this.parentLovValue, this.excludeLov, this.multiple)
					lovs = lovs.filter(lov => lov.name.indexOf(filterText) > -1).map(({val}) => (val))
					if (lovs.length === 0) {
						lovs = ['noMachFilterText']
					}
					return {
						value: `[${lovs.join(',')}]`,
						operator: 'in',
					}
				}
			},
		},
	},
}
</script>

